import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import ProductSpecificationsContainer from './product-specifications/ProductSpecifications.container';
import ProductManagementContainer from './product-management/ProductManagement.container';
import ProductListingManagementContainer from './product-management/product-listing-management/ProductListingManagement.container';
import BuyerListingManagementContainer from './product-management/buyer-listing-management/BuyerListingManagement.container';
import AccountManagementContainer from './account-management/AccountManagement.container';
import AccountContainer from './account-management/account/Account.container';
import SupportContainer from './support/Support.container';
import MarketBuzzManagementContainer from './market-buzz-management/MarketBuzzManagement.container';
import DealRoomManagementContainer from './deal-room-management/DealRoomManagement.container';
import DealManagementContainer from './deal-room-management/deal-management/DealManagement.container';
import UserRoleManagementContainer from './user-role-management/UserRoleManagement.container';

const AdminContainer = () => {
  const userGroups = useSelector(({ party }) => party.userGroups);

  let defaultPath;
  if (userGroups.includes('facilitator')) {
    defaultPath = '/admin/support';
  } else if (userGroups.includes('admin')) {
    defaultPath = '/admin/product-specifications';
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to={defaultPath} />} />
      <Route path="/product-specifications" element={<ProductSpecificationsContainer />} />
      <Route path="/product-specifications/:specification" element={<ProductSpecificationsContainer />} />
      <Route path="/product-management" element={<ProductManagementContainer />} />
      <Route
        path="/product-management/product-listing/:productExternalReference"
        element={<ProductListingManagementContainer />}
      />
      <Route
        path="/product-management/buyer-listing/:productExternalReference"
        element={<BuyerListingManagementContainer />}
      />
      <Route path="/account-management" element={<AccountManagementContainer />} />
      <Route path="/account-management/:organisationExternalReference" element={<AccountContainer />} />
      <Route path="/support" element={<SupportContainer />} />
      <Route path="/support/:activeChatExternalReference" element={<SupportContainer />} />
      <Route path="/market-buzz-management" element={<MarketBuzzManagementContainer />} />
      <Route path="/deal-room-management" element={<DealRoomManagementContainer />} />
      <Route path="/deal-room-management/:contractExternalReference" element={<DealManagementContainer />} />
      <Route path="/user-role-management" element={<UserRoleManagementContainer />} />
    </Routes>
  );
};

export default AdminContainer;
